import axios from 'axios';
import { clearUserInfoStorage } from './userInfo';
import { setupCryptoInterceptor } from './crypto/interceptor';

// const apiURL = process.env.NODE_ENV === 'development' ? '' : 'http://60.165.149.138:7074';
const apiURL = process.env.REACT_APP_ENV === 'dev' ? '' : 'https://www.qyscjg.cn'; // 正式环境
// API 基地址（crypto 加解密协商/签名相对路径计算复用）
const apiBase = `${apiURL}/jeecg-boot`;
export const getApiBase = () => apiBase;

// 获取 token 的函数
const getToken = () => {
    return sessionStorage.getItem('token');
};

const request = axios.create({
    baseURL: apiBase,
});

// 先注册数据传输加解密 + HMAC 签名拦截器（受 REACT_APP_CRYPTO_ENABLED 开关控制）
// axios 响应拦截器为 FIFO 执行，crypto 的错误拦截器需先注册：
// 会话过期(4011/4010)时优先重试，其他错误再交给后续 401 处理逻辑
setupCryptoInterceptor(request);

// 请求拦截器：从 sessionStorage 获取 token
// axios 请求拦截器为 LIFO 执行，token 拦截器后注册先执行，确保 X-Access-Token 不被覆盖
request.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers['X-Access-Token'] = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

request.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            sessionStorage.removeItem('token');
            clearUserInfoStorage();
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default request;
export { request };
